
import { Vue, Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AccountModule from '@/store/modules/Account';
import ProfileModule from '@/store/modules/Profile';
import BalanceModule from '@/store/modules/Balance';
import GeneralModule from '@/store/modules/General';
import UserData from '@/data/User';

@Component
export default class ManageMixin extends Vue {
  AccountInstance = getModule(AccountModule, this.$store);

  ProfileInstance = getModule(ProfileModule, this.$store);

  BalanceInstance = getModule(BalanceModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  currentSelectUser = '';

  userList: Array<object> = [];

  page = 1;

  limit = 100;

  PaginationDetail: any = {
    current: 1,
    amount: 0,
    size: 100,
  }

  currency = '';

  isMulticurrency = false;

  alert(res) {
    return res;
  }

  modal = UserData.initialModal();

  selected: any = {};

  modalData: any = {
    profile: UserData.initialUserInfo(),
    lock: UserData.initialLock(),
    password: UserData.initialPassword(),
    pt: UserData.initialPT(),
    refill: UserData.initialRefill(),
    deduct: UserData.initialDeduct(),
    permission: UserData.initialPermission(),
    userPermission: UserData.initialUserPermission(),
    isFeature: UserData.initialModal(),
    statusFeature: UserData.initialModal(),
  }

  lock(user) {
    this.currentSelectUser = user._id;
    const { isSuspend, username } = user;
    this.modalData.lock = {
      activate: isSuspend,
      username,
    };
    this.modal.lock = true;
  }

  async submitLock() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.AccountInstance.ActiveUser({
      userId: this.currentSelectUser,
      activate: !this.modalData.lock.activate,
    });
    this.GeneralInstance.toggleLoading(false);
    this.selected.isSuspend = !this.modalData.lock.activate;
    this.alert(res);
  }

  editInfo(user) {
    this.modalData.profile = { ...user.profile };
    this.currentSelectUser = user._id;
    this.modal.editInfo = true;
  }

  async submitEditInfo() {
    const { profile } = this.selected;
    this.GeneralInstance.toggleLoading(true);
    const res = await this.ProfileInstance.UpdateProfile({
      userId: this.currentSelectUser ? this.currentSelectUser : this.selected._id,
      profile,
    });
    this.GeneralInstance.toggleLoading(false);
    this.alert(res);
  }

  resetPassword(user) {
    this.modalData.password.username = user.username;
    this.currentSelectUser = user._id;
    this.modal.password = true;
  }

  async submitResetPassword() {
    const { password } = this.modalData;
    this.GeneralInstance.toggleLoading(true);
    const res = await this.AccountInstance.ResetPassword({
      userId: this.currentSelectUser,
      ...password,
    });
    this.GeneralInstance.toggleLoading(false);
    this.alert(res);
  }

  refillCredit(user, showFilterCurrency) {
    this.modalData.refill = UserData.initialRefill();
    this.modalData.refill.username = user.username;
    this.modalData.refill.source = user.source;
    this.modalData.refill.currency = user.currency ? user.currency : 'THB';
    this.currentSelectUser = user._id;
    this.modal.refill = true;
    this.isMulticurrency = showFilterCurrency;
  }

  setFeature(user) {
    this.modalData.username = user.username;
    this.modalData.Feature = user;
    this.modalData.parent = user.parent._id;
    this.modalData.statusFeature = user.isFeature;
    this.modal.isFeature = true;
  }

  setFeatureSelf(user, selfFeature) {
    this.modalData.Feature = user;
    this.modalData.username = user.username;
    this.modalData.parent = user._id;
    this.modalData.statusFeature = selfFeature;
    this.modal.isFeature = true;
  }

  async submitRefillCredit() {
    this.modalData.refill.amount = +this.modalData.refill.amount;
    this.GeneralInstance.toggleLoading(true);
    const res = await this.BalanceInstance.Refill({
      userId: this.currentSelectUser,
      ...this.modalData.refill,
      isMulticurrency: this.isMulticurrency,
    });
    this.ProfileInstance.GetBalance();
    this.GeneralInstance.toggleLoading(false);
    this.alert(res);
  }

  deductCredit(user, showFilterCurrency) {
    this.modalData.deduct = UserData.initialDeduct();
    this.modalData.deduct.username = user.username;
    this.modalData.deduct.source = user.source;
    this.modalData.deduct.balance = user.wallet.balance;
    this.modalData.deduct.currency = user.currency ? user.currency : 'THB';
    this.currentSelectUser = user._id;
    this.modal.deduct = true;
    this.isMulticurrency = showFilterCurrency;
  }

  async submitDeductCredit() {
    this.modalData.deduct.amount = +this.modalData.deduct.amount;
    this.GeneralInstance.toggleLoading(true);
    const res = await this.BalanceInstance.Refill({
      userId: this.currentSelectUser,
      currency: this.currency,
      ...this.modalData.deduct,
      isMulticurrency: this.isMulticurrency,
    });
    this.ProfileInstance.GetBalance();
    this.GeneralInstance.toggleLoading(false);
    this.alert(res);
  }

  colorStatus(status) {
    return `${status ? 'red' : 'green'}-text`;
  }
}
